import { db_DDIs } from "./db.i18n";

export const DDIs = db_DDIs;

export const DDIsWithKeys = db_DDIs;

export const filterDDIs = (search, t) => {
  if (!search || search.trim().length === 0) return DDIs;
  search = search
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");

  const filtered = DDIs.map((cat) => {
    const meds = cat?.medications?.filter(
      (drug) => {
        const translatedName = t ? t("ddis_common:" + drug.nameKey) : drug.nameKey;
        return translatedName
          .toLowerCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "")
          .search(search) >= 0;
      }
    );
    return {
      categoryKey: cat.categoryKey,
      medications: meds ?? [],
    };
  });
  return filtered.filter((cat) => cat.medications.length > 0);
};

export const DDI_Groups = () => {
  return DDIs.map((cat) => {
    const group = { ...cat };
    delete group.medications;
    return group;
  });
};
export const DDI_GetGroup = (category) => {
  return DDIs.find((g) => {
    return g.categoryKey === category;
  });
};

export const getDrugGroup = (drugName) => {
  if (!drugName || drugName.length === 0) return DDIs;

  const filtered = DDIs.map((cat) => {
    const meds = cat?.medications?.filter((drug) => drug.name === drugName);
    return {
      category: cat.categoryKey,
      medications: meds ?? [],
    };
  });
  const groups = filtered.filter((cat) => cat.medications.length > 0);
  if (groups.length === 1) {
    return groups[0].category;
  }
  return null;
};
